// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TVPAGE .swiper .swiper-wrapper .swiper-slide{padding:0}`, "",{"version":3,"sources":["webpack://./src/components/Grid/GridItem/swiper.css"],"names":[],"mappings":"AACA,8CACI,SAAA","sourcesContent":["@import \"variables.json\";\n.swiper .swiper-wrapper .swiper-slide{\r\n    padding: 0\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
